module.exports = __webpack_public_path__ + "media/פעמון.f36e5150.mp3";